import styled from '@emotion/styled';

export const SkillLabel = styled.div({
    alignItems: 'center',
    background: '#f1f1f0',
    borderRadius: '0.5rem',
    boxShadow:
        '0.711px 0.889px 0.889px 0px rgba(251, 251, 255, 0.7) inset, -0.889px -0.711px 0.889px 0px rgba(251, 251, 255, 0.5) inset, 0px 2.667px 0.889px 0px rgba(80, 80, 82, 0.01), 0px 1.778px 0.889px 0px rgba(80, 80, 82, 0.05), 0px 0.889px 0.889px 0px rgba(80, 80, 82, 0.09)',
    display: 'flex',
    gap: '0.5rem',
    height: '2rem',
    padding: '0.3rem 0.7rem',
    whiteSpace: 'nowrap',
    width: 'fit-content',
});
